import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import axios from 'axios';
import VCurrencyField from 'v-currency-field';
import { VTextField } from 'vuetify/lib'  //Globally import VTextField

Vue.component('v-text-field', VTextField)

Vue.use(VCurrencyField, {
  decimalLength: 2,
  autoDecimalMode: true,
  min: null,
  max: null,
  defaultValue: 0,
  valueAsInteger: false,
  allowNegative: false
});

Vue.config.productionTip = false

Vue.mixin({
  data: function () {
    return {
    };
  },
  methods: {
    async send_auth_http_request(end_point, data) {
      var auth_data = {
        user_id: this.$store.getters.getUserID,
        username: this.$store.getters.getUserName,
      };
      var token = (await this.send_http_request('generateToken', auth_data)).data.token;
      return new Promise((resolve, reject) => {
        axios({
          method: 'post',
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          },
          url: `${process.env.VUE_APP_DEV_SERVER_URL}/${end_point}`,
          data: data,
        }).then(response => {
          resolve(response);
        }).catch(error => {
          reject(error);
        });
      });
    },
    load_all_machines_basic_info() {
      this.send_http_request('loadCompanyMachinesBasicInfo', { company_doc_id: this.$store.getters.getUserCompanyDocId }).then(response => {
        if (response.data.status == 'OK') {
          this.$store.dispatch('updateMachineList', { machineList: response.data.result });
          if (this.$store.getters.getSelectedMachine == '') {
            this.$store.dispatch('updateSelectedMachine', { selectedMachine: `${response.data.result[0].machine_id} - ${response.data.result[0].machine_name}` });
          }
        }
      }).catch(error => {
        console.log(error);
      });
    },
    async send_http_request(end_point, data) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'post',
          url: `${process.env.VUE_APP_DEV_SERVER_URL}/${end_point}`,
          data: data,
        }).then(response => {
          resolve(response);
        }).catch(error => {
          reject(error);
        });
      });
    },
    async upload_file(end_point, data) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'post',
          url: `${process.env.VUE_APP_DEV_SERVER_URL}/${end_point}`,
          data: data,
          headers: {
            'Content-Type': 'multipart/form-data'
          },
        }).then(response => {
          resolve(response);
        }).catch(error => {
          reject(error);
        });
      });
    },
    async upload_image(end_point, data) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'post',
          url: `${process.env.VUE_APP_DEV_SERVER_URL}/${end_point}`,
          data: data,
          headers: {
            'Content-Type': 'multipart/form-data'
          },
        }).then(response => {
          resolve(response);
        }).catch(error => {
          reject(error);
        });
      });
    },
    show_close_loading(action, text) {
      var payload = {
        loading_text: action == 'show' ? text : '',
        show_loading: action == 'show' ? true : false,
      };
      this.$store.dispatch("updateLoadingText", payload);
      this.$store.dispatch("updateShowLoading", payload);
    },
    show_snack_bar(status, text) {
      var payload = {
        snackbar: true,
        snackbar_color: status == 'success' ? 'success' : 'error',
        snackbar_text: text,
      };
      this.$store.dispatch("updateSnackbar", payload);
      this.$store.dispatch("updateSnackbarColor", payload);
      this.$store.dispatch("updateSnackbarText", payload);

      setTimeout(() => {
        var payload = {
          snackbar: false,
          snackbar_color: '',
          snackbar_text: '',
        };
        this.$store.dispatch("updateSnackbar", payload);
        this.$store.dispatch("updateSnackbarColor", payload);
        this.$store.dispatch("updateSnackbarText", payload);
      }, this.$store.getters.getSnackbarTimeout);
    },
    only_for_number($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;

      if (keyCode < 48 || keyCode > 57) {
        $event.preventDefault();
      }
    },
    only_for_number_semicolon($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;

      if (keyCode < 48) {
        $event.preventDefault();
      } else if (keyCode > 57) {
        if (keyCode == 58 || keyCode > 59) {
          $event.preventDefault();
        }
      }
    },
    is_numeric(value) {
      if (isNaN(value)) {
        return false;
      }
      return true;
    },
  },
})

new Vue({
  router,
  store,
  vuetify,
  render: function (h) { return h(App) }
}).$mount('#app')
